<template>
  <o-modal
    ref="modal"
    :title="$t('components.schedule.actions.settings.title')"
    :options="[
      { text: $t('general.close'), type: 'cancel' }
    ]"
    modal-class="m-2 bg-gray-50 rounded-lg shadow-lg pointer-events-auto overflow-hidden sm:max-w-md sm:w-full h-full max-h-lg dark:bg-gray-900"
    content-class="mx-auto max-w-lg h-full flex flex-col bg-white dark:bg-gray-900"
  >
    <div class="text-base leading-5 text-gray-600 -mt-2 dark:text-gray-300">
      <o-field-group :label="$t('general.resources')" :info="$t('components.schedule.actions.settings.resourcesInfo')" class="block pb-5">
        <segment-field
          v-model="_showResources"
          :options="showResourceOptions"
        />
      </o-field-group>

      <o-field-group :label="$t('components.schedule.actions.settings.columnSize')" :info="$t('components.schedule.actions.settings.columnSizeInfo')" class="block pb-5">
        <segment-field
          v-model="_sectionSize"
          :options="sectionSizeOptions"
        />
      </o-field-group>
    </div>
  </o-modal>
</template>

<script setup lang="ts">
import {
  ToggleField,
  RangeField,
  SegmentField,
} from '@/components/fields'

import { useUIStore } from '~/stores/useUIStore'

const { $i18n } = useNuxtApp()
const uiStore = useUIStore()

const modal = ref<any>()

const showResourceOptions = [
  { label: $i18n.t('general.all'), value: 'all' },
  { label: $i18n.t('general.active'), value: 'active' },
  { label: $i18n.t('general.none'), value: 'none' },
]

const sectionSizeOptions = [
  { label: $i18n.t('general.small'), value: 140 },
  { label: $i18n.t('general.medium'), value: 200 },
  { label: $i18n.t('general.large'), value: 300 },
]

const viewOptions = [
  { label: $i18n.t('datetime.labels.day'), value: '/schedule/day' },
  { label: $i18n.t('datetime.labels.week'), value: '/schedule/week' },
  { label: $i18n.t('general.timetable'), value: '/schedule/timetable' },
]

const _showResources = computed({
  get () {
    return uiStore.schedule.showResources
  },
  set (value: string) {
    uiStore.setSchedule({ key: 'showResources', value })
  },
})

const _sectionSize = computed({
  get () {
    return uiStore.schedule.sectionSize
  },
  set (value: number) {
    uiStore.setSchedule({ key: 'sectionSize', value })
  },
})

const open = () => {
  modal.value.open()
}

defineExpose({
  open,
})
</script>
